namespace Solovis.Reports.Parameters {

    export class DecimalParameterControl extends Solovis.UI.BaseControl {

        public initialParameterValue;

        public textInput: JQuery;
        public static hasNewRender = true;


        constructor(options) {
            super(options);

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
        }


        public doInit() {
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        public async doRenderNew() {
            var self = this;
            const target = this.container[0];
            const id = Solovis.UX.Utils.generateId();
            await Solovis.UX.Utils.placeComponent(
                "Input",
                target,
                {
                    id,
                    defaultValue: this.initialParameterValue,
                    onChange: (value) => {
                        self.notifyParameterValueChanged();
                    },
                    placeholder: "Enter a numeric value",
                    inputVariant: "decimal"
                }
            );
            this.textInput = $(`#${id}`);
        }

        public doRenderClassic() {
            var self = this;

            this.container.addClass("report-param-decimal");

            this.textInput = $("<input>").attr("type", "text").appendTo(this.container)
                .css("margin", 0).css("width", "100px");

            if (this.initialParameterValue !== null) {
                this.textInput.val(this.initialParameterValue);
            }

            $(this.textInput).change(function () {
                self.notifyParameterValueChanged();
            });
        }

        public setParameterValue(newValue) {
            if (this.textInput) {
                this.textInput.val(newValue);
            }
            else {
                this.initialParameterValue = newValue;
            }
        }

        public getParameterValue() {
            if (this.textInput) {
                var textValue = this.textInput.val();

                // Javascript doesn't support Decimal precision numbers, so we leave the decimal number as text for now.
                // However, we should still add proper validation at some point.

                return textValue;
            }
            else {
                return this.initialParameterValue;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }

    }

}